import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

export default function ExchangeRowActions({ row, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);

  const closeAndRun = (handler) => {
    setOpen(false);
    handler?.();
  };

  return (
    <Dropdown
      isOpen={open}
      toggle={() => setOpen((value) => !value)}
      className="ex-actions-menu"
    >
      <DropdownToggle size="sm" color="light" caret className="ex-actions-menu__toggle">
        Actions
      </DropdownToggle>
      <DropdownMenu end container="body" className="ex-actions-menu__list">
        <DropdownItem onClick={() => closeAndRun(() => onEdit(row))}>
          <i className="fa fa-pencil me-2" />
          Edit period
        </DropdownItem>
        <DropdownItem
          className="text-danger"
          onClick={() => closeAndRun(() => onDelete(row))}
        >
          <i className="fa fa-trash me-2" />
          Delete period
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
